export const passThroughComponent = (component) => component('router-view')
